export const IPFS_GATEWAY = "https://cloudflare-ipfs.com/"
